import { render, staticRenderFns } from "./articlesContent.vue?vue&type=template&id=0b4026bc&scoped=true&"
import script from "./articlesContent.vue?vue&type=script&lang=js&"
export * from "./articlesContent.vue?vue&type=script&lang=js&"
import style0 from "./articlesContent.vue?vue&type=style&index=0&id=0b4026bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4026bc",
  null
  
)

export default component.exports